//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core';

//Estilo CSS do componente
const styles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'column', 
        alignItems: 'center'
    }
});

/**
 * Componente para exibir um loader circular centralizado no componente pai
 * @param {Object} props Propriedades do componente
 * @param {Object} classes Classes CSS do componente
 */
function CenteredCircularProgress({ classes }) {
    return (
        <div className={classes.container} ><CircularProgress /></div> 
    );
}

CenteredCircularProgress.propTypes = {
    classes: PropTypes.shape({
        container: PropTypes.string
    })
};

export default withStyles(styles)(CenteredCircularProgress);